import React from 'react';
import { Modal, ScrollView, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { allStyles } from './FormStyles';

const styles = StyleSheet.create(allStyles);

const SelectModal = ({
    visible,
    title,
    message,
    items,
    selectedItem,
    onSelect,
    onBlankPress,
}) => {
    return (
        <Modal
            visible={visible}
            transparent={true}
            animationType={'fade'}
        >
            <TouchableOpacity style={styles.modalBackdrop} activeOpacity={1} onPress={() => { 
                if (typeof onBlankPress === 'function') onBlankPress();
            }}>
                <View style={styles.modalContainer}>
                    <Text style={styles.modalTitle}>{title}</Text>
                    <ScrollView
                        style={{marginTop:16}}
                        contentContainerStyle={{paddingHorizontal:20, paddingBottom:20}}
                        showsVerticalScrollIndicator={false}
                    >
                        {(message && message.length > 0) &&
                        <Text style={[styles.text, {textAlign:'center'}]}>{message}</Text>
                        }
                        {items.map((item, i) => 
                            <TouchableOpacity key={i} style={styles.modalSelectItemContainer} onPress={() => {
                                if (typeof onSelect === 'function') onSelect(item);
                            }}>
                                <View style={{flex:1}}>
                                    <Text style={styles.title}>{item.label}</Text>
                                    {item.subLabel &&
                                    <Text style={styles.text}>{item.subLabel}</Text>
                                    }
                                </View>
                                <View style={selectedItem.value === item.value ? styles.modalSelectItemBubbleSeleted : styles.modalSelectItemBubble}/>
                            </TouchableOpacity>
                        )}
                    </ScrollView>
                </View>
            </TouchableOpacity>
        </Modal>
    );
};

export default SelectModal;